import { Anchor, Box, Paragraph } from '@zillow/constellation-10';

import InheritText from '../InheritText';

import { useGetUser } from '../../hooks/queries/user';

import { paths as zrmPaths } from '../../utils/zrmPathsManifest';

import { inheritColorClass } from '../../styles';

const POST_FIRST_LISTING_URL_QUERY = '?postingPath=true';

const SignInCTA = () => {
  const {
    data: { loggedIn: isLoggedIn, isInitialMultiFactorAuthenticationRequired },
  } = useGetUser();

  const isPartiallyAuthenticated = isLoggedIn || isInitialMultiFactorAuthenticationRequired;

  if (isPartiallyAuthenticated) {
    return null;
  }

  return (
    <Box css={{ marginTop: '400' }} data-testid="SignInCTA">
      <Paragraph textStyle="body-sm" css={{ height: '500', lineHeight: '20px', color: 'inherit' }}>
        <InheritText>Already have an account?</InheritText>{' '}
        <Anchor
          className={inheritColorClass}
          href={zrmPaths.zrmSignInPage(`${zrmPaths.propertiesPage}${POST_FIRST_LISTING_URL_QUERY}`) || ''}
        >
          <strong>Sign in</strong>
        </Anchor>
      </Paragraph>
    </Box>
  );
};

export default SignInCTA;
